/**
 * API相关常量
 */

// API基础URL
export const API_BASE_URL = 'https://www.wensonglaw.com'

// API路径
export const API_PATHS = {
  // 网站配置
  CONFIG: '/api/index/config',

  // 律师相关
  LAWYER_LIST: '/api/index/get_lawyer_list',
  LAWYER_INFO: '/api/index/get_lawyer_info',

  // 文章相关
  ARTICLE_LIST: '/api/index/get_article_list',
  ARTICLE_INFO: '/api/index/get_article_info',

  // 地区相关
  AREA: '/api/index/get_area',

  // 表单提交
  SUBMIT_CASE: '/api/index/submit_cases',
  SUBMIT_COOPERATE: '/api/index/submit_cooperate',

  // 文件上传
  UPLOAD: '/api/index/upload',

  // 职位相关
  JOB_LIST: '/api/index/get_job_list',
  JOB_INFO: '/api/index/get_job_info'
}

// 响应状态码
export const RESPONSE_CODE = {
  SUCCESS: 200,
  SUCCESS_ALT: 1,
  ERROR: 500,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404
}

// 分页默认参数
export const DEFAULT_PAGE_PARAMS = {
  page: 1,
  limit: 10
}
